import {FC} from 'react'

export const SuccessIcon: FC<{size?: number}> = ({size = 48}) => {
    return (
        <svg width={size} height={size} viewBox="0 0 54 54" fill="none">
            <path
                d="M27 3V3C13.7452 3 3 13.7452 3 27V27C3 40.2548 13.7452 51 27 51V51C40.2548 51 51 40.2548 51 27V27"
                stroke="url(#paint0_linear_1210_14259)"
                strokeWidth="4.27"
                strokeLinecap="round"
            />
            <rect
                x="7.70898"
                y="7.4325"
                width="39.1349"
                height="39.1349"
                rx="19.5675"
                fill="url(#paint1_linear_1210_14259)"
                fillOpacity="0.1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M48.1798 12.1753C49.0314 11.3235 49.0308 9.94318 48.1783 9.09227C47.3258 8.24135 45.9443 8.24204 45.0927 9.09381L24.8173 29.3726L19.8154 24.3749C18.9634 23.5235 17.5819 23.5235 16.7299 24.3749C15.8778 25.2262 15.8778 26.6065 16.7299 27.4578L23.2753 33.9978C23.6846 34.4068 24.2398 34.6365 24.8186 34.6363C25.3975 34.6362 25.9525 34.4062 26.3616 33.9971L48.1798 12.1753Z"
                fill="url(#paint2_linear_1210_14259)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1210_14259"
                    x1="27"
                    y1="51"
                    x2="27"
                    y2="3"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#30A46C" />
                    <stop offset="1" stopColor="#5BB98C" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1210_14259"
                    x1="27.2764"
                    y1="46.5674"
                    x2="27.2764"
                    y2="7.4325"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#30A46C" />
                    <stop offset="1" stopColor="#5BB98C" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_1210_14259"
                    x1="32.4545"
                    y1="34.6363"
                    x2="32.4545"
                    y2="8.45453"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#30A46C" />
                    <stop offset="1" stopColor="#5BB98C" />
                </linearGradient>
            </defs>
        </svg>
    )
}
